import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay, tap } from 'rxjs/operators';

import { ErrorModalAssistant } from '../../../modals/error-modal/error-modal.assistant';
import { AuthSecurityService } from '../../../../services/shared/auth/auth-security/auth-security.service';
import { ENVIRONMENT } from '../../../../../environments';


@Injectable()
export class TimeGuard {

	//** Configurations */
	private readonly SERVER_URL: string = ENVIRONMENT.BACKEND.SERVER_URL;
	private timeSync: Observable<boolean> = null;

	constructor(
		private errorModalAssistant 	: ErrorModalAssistant,
		private authSecurityService		: AuthSecurityService,
		private backend					: HttpBackend,
		private http					: HttpClient = null
	) {
		this.http = new HttpClient(this.backend);
	}

	canLoad(): Observable<boolean> {
		return this.synchronizeTime().pipe(tap((ready: boolean) => {
			if (!ready) this.errorModalAssistant.showServerError();
		}));
	}

	synchronizeTime(): Observable<boolean> {
		if (!this.timeSync) {
			this.timeSync = this.getTimeStamp().pipe(
				map((res: ITimestamp) => {
					this.authSecurityService.createTimeOffset(res.timestamp);
					return true;
				}),
				catchError(() => {
					this.timeSync = null;
					return of(false);
				}),
				shareReplay({ bufferSize: 1, refCount: false })
			);
		}
		return this.timeSync;
	}

	getTimeStamp(): Observable<ITimestamp> {
		return this.http.get<ITimestamp>(`${this.SERVER_URL}timestamp`, {
			headers: new HttpHeaders()
		});
	}
}


//** Interfaces --------------------------------- */
interface ITimestamp {
	timestamp	: number;
}
